const SHARED_PASSWORD_ENDPOINT = process.env.REACT_APP_SHARED_PASSWORD_ENDPOINT
console.log(
  `process.env.REACT_APP_MULTI_LOGIN: ${process.env.REACT_APP_MULTI_LOGIN}`,
)
console.log(
  `process.env.MULTILOGIN_RECOVERY_LOGIN_NAME_SERVICE: ${process.env.MULTILOGIN_RECOVERY_LOGIN_NAME_SERVICE}`,
)
console.log(
  `process.env.REACT_APP_CUSTOM_LOGIN_ENDPOINT: ${process.env.REACT_APP_CUSTOM_LOGIN_ENDPOINT}`,
)
const CUSTOM_LOGIN_SERVICES =
  process.env.REACT_APP_MULTI_LOGIN === 'true'
    ? process.env.REACT_APP_MULTILOGIN_RECOVERY_LOGIN_NAME_SERVICE
    : process.env.REACT_APP_CUSTOM_LOGIN_ENDPOINT
console.log(`Using CUSTOM_LOGIN_SERVICES: ${CUSTOM_LOGIN_SERVICES}`)
const MFA_SERVICES = process.env.REACT_APP_MFA_ENDPOINT || CUSTOM_LOGIN_SERVICES // Falls back to CUSTOM_LOGIN_SERVICES if not set
const STATIC_PRIMARY_BUCKET = process.env.REACT_APP_STATIC_CONTENT_PRIMRY_BUCKET
const STATIC_SECONDARY_BUCKET =
  process.env.REACT_APP_STATIC_CONTENT_SECONDARY_BUCKET
const GET_ALLOWABLE_MEMBERS_ENDPOINT =
  process.env.REACT_APP_GET_ALLOWABLE_MEMBERS_ENDPOINT
const SWITCH_OKTA_MEMBER_ACCOUNT_ENDPOINT =
  process.env.REACT_APP_SWITCH_OKTA_MEMBER_ACCOUNT_ENDPOINT
const MULTILOGIN_RECOVERY_LOGIN_NAME_SERVICE =
  process.env.REACT_APP_MULTILOGIN_RECOVERY_LOGIN_NAME_SERVICE

const apiConfig = {
  /**
   * Log user's login details in S3 for shared password report analysis
   */
  logUserDetails: () => `${SHARED_PASSWORD_ENDPOINT}/custom-logs`,

  /**
   * Logs error in Cloud Watch
   */
  logError: () => `${CUSTOM_LOGIN_SERVICES}/log-error`,

  /**
   * Update user's agreement acceptance date and
   * move to group 'Active Members - TOU Accepted'
   */
  updateUserAgreementAcceptance: () =>
    `${CUSTOM_LOGIN_SERVICES}/update-user-agreement-acceptance`,

  /**
   * Recover username from Okta
   */
  recoverUsername: (email: string) =>
    `${CUSTOM_LOGIN_SERVICES}/recover-username?email=${email}`,

  /**
   * Recover username from Okta for multi-login app (brightmls-dev-imp.okta.com)
   */
  recoverMultiLoginUsername: (email: string) =>
    `${MULTILOGIN_RECOVERY_LOGIN_NAME_SERVICE}/multilogin-recover-username?email=${email}`,

  /**
   * After resetting user's password in Okta also reset in Forgerock
   */
  resetForgerockPassword: () =>
    `${CUSTOM_LOGIN_SERVICES}/reset-forgerock-password`,

  /**
   * Get Password Policy from Okta
   */
  getPasswordPolicy: () => `${CUSTOM_LOGIN_SERVICES}/password-policy`,

  /**
   * Change password in Okta
   */
  changePassword: () => `${CUSTOM_LOGIN_SERVICES}/change-password`,

  /**
   * After resetting user's password in Okta we save it encrypted in DynamoDb table in case we need to switch from Okta to something else and transfer the passwords
   */
  savePassword: () => `${CUSTOM_LOGIN_SERVICES}/save-password`,

  /**
   * Get unmasked phone number (DEPRECATED - use getMfaFactors instead)  */
  getPhoneNumber: () => `${CUSTOM_LOGIN_SERVICES}/factordetails`,

  /**
   * Update sms factor mobile number enroll and activate (DEPRECATED - use updateMfaFactor instead)  */
  updateFactorDetails: () => `${CUSTOM_LOGIN_SERVICES}/update-sms-factor`,

  /**
   * Get the user's email by stateToken (used for forced email enrollment)
   */
  getUserInfo: (stateToken: string) =>
    `${CUSTOM_LOGIN_SERVICES}/get-user-info?stateToken=${encodeURIComponent(stateToken)}`,

  /**
   * MFA Management Endpoints (NEW - uses REACT_APP_MFA_ENDPOINT in dev)
   */

  /**
   * Get all MFA factors for the authenticated user
   */
  getMfaFactors: () => `${MFA_SERVICES}/mfa/factors`,

  /**
   * Enroll a new MFA factor (SMS, Email, or TOTP)
   */
  enrollMfaFactor: () => `${MFA_SERVICES}/mfa/factors/enroll`,

  /**
   * Activate an enrolled MFA factor with verification code
   */
  activateMfaFactor: (factorId: string) =>
    `${MFA_SERVICES}/mfa/factors/${factorId}/activate`,

  /**
   * Update an existing MFA factor (e.g., change phone number)
   */
  updateMfaFactor: (factorId: string) =>
    `${MFA_SERVICES}/mfa/factors/${factorId}`,

  /**
   * Remove/delete an MFA factor
   */
  removeMfaFactor: (factorId: string) =>
    `${MFA_SERVICES}/mfa/factors/${factorId}`,

  /**
   * Resend verification code for a factor
   */
  resendMfaCode: (factorId: string) =>
    `${MFA_SERVICES}/mfa/factors/${factorId}/resend`,

  /**
   * Verify MFA factor during login challenge
   */
  verifyMfaFactor: () => `${MFA_SERVICES}/mfa/verify`,

  /**
   * Send challenge to a specific factor
   */
  challengeMfaFactor: (factorId: string) =>
    `${MFA_SERVICES}/mfa/factors/${factorId}/challenge`,

  /**
   * Get login article   */
  loginArticle: () =>
    `https://${STATIC_PRIMARY_BUCKET}.s3.amazonaws.com/Unauthenticated/ssoLogin.json`,

  /**
   * Get login article   */
  mfaArticle: () =>
    `https://${STATIC_PRIMARY_BUCKET}.s3.amazonaws.com/Unauthenticated/ssoMfa.json`,

  /**
   * Get login article from secondary bucket   */
  loginArticleSecondary: () =>
    `https://${STATIC_SECONDARY_BUCKET}.s3.amazonaws.com/Unauthenticated/ssoLogin.json`,

  /**
   * Get subscription agreement   */
  subscriptionAgreement: () =>
    `https://${STATIC_PRIMARY_BUCKET}.s3.amazonaws.com/Unauthenticated/subscription-agreement.json`,

  /**
   * Get subscription agreement from secondary bucket   */
  subscriptionAgreementSecondary: () =>
    `https://${STATIC_SECONDARY_BUCKET}.s3.amazonaws.com/Unauthenticated/subscription-agreement.json`,

  getAllowableMembers: () => `${GET_ALLOWABLE_MEMBERS_ENDPOINT}`,
  switchOktaMemberAccount: (memberId: string) =>
    `${SWITCH_OKTA_MEMBER_ACCOUNT_ENDPOINT}?impersonate=${memberId}`,

  /**
   * Self-enroll user into the MFA group (Enhanced Security MFA SMS Only)
   */
  enrollMfaGroup: () => `${MFA_SERVICES}/groups/enroll`,

  /**
   * Check if the user has a record in the Okta-Imp org (multi-login user)
   */
  isMultiLoginUser: (memberMlsId: string) =>
    `${CUSTOM_LOGIN_SERVICES}/ismultiloginenabled?memberMlsId=${memberMlsId}`,
}

export default apiConfig
